import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { ReachAssessment } from '../../../services/reachService';

const STAGES = ['r', 'e', 'a', 'c', 'h'];
const STAGE_LABELS: Record<string, string> = { r: 'R', e: 'E', a: 'A', c: 'C', h: 'H' };

function avg(values: (number | undefined)[]): number {
  const valid = values.filter(v => v !== undefined) as number[];
  if (!valid.length) return 0;
  return valid.reduce((a, b) => a + b, 0) / valid.length;
}

interface Props {
  assessments: ReachAssessment[];
}

export const ResultsGapChart: React.FC<Props> = ({ assessments }) => {
  const data = STAGES.map(stage => {
    const s = stage as 'r' | 'e' | 'a' | 'c' | 'h';
    return {
      name: STAGE_LABELS[stage],
      Individual: +avg(assessments.map(a => a.individual[s] as any)).toFixed(2),
      Organisational: +avg(assessments.map(a => a.organisational[s] as any)).toFixed(2),
    };
  });

  if (!assessments.length) return (
    <div className="py-12 text-center text-slate-400 text-sm">No assessment data to display.</div>
  );

  return (
    <ResponsiveContainer width="100%" height={260}>
      <BarChart data={data} margin={{ top: 8, right: 16, left: 0, bottom: 0 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" />
        <XAxis dataKey="name" tick={{ fontSize: 12, fill: '#64748b' }} />
        <YAxis domain={[0, 4]} ticks={[1, 2, 3, 4]} tick={{ fontSize: 11, fill: '#64748b' }} />
        <Tooltip
          formatter={(v: number | undefined) => (v != null ? v.toFixed(2) : '')}
          contentStyle={{ borderRadius: 8, border: '1px solid #e2e8f0', fontSize: 12 }}
        />
        <Legend wrapperStyle={{ fontSize: 12 }} />
        <Bar dataKey="Individual" fill="#00c7c4" radius={[4, 4, 0, 0]} />
        <Bar dataKey="Organisational" fill="#6366f1" radius={[4, 4, 0, 0]} />
      </BarChart>
    </ResponsiveContainer>
  );
};
